import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=b4b4632c&scoped=true&"
import script from "./Support.vue?vue&type=script&lang=js&"
export * from "./Support.vue?vue&type=script&lang=js&"
import style0 from "./Support.vue?vue&type=style&index=0&id=b4b4632c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b4632c",
  null
  
)

export default component.exports